<template>
  <div class="sm:flex items-center p-2 sm:py-6 sm:px-4 rounded-lg border border-gray-200 shadow-sm">
    <div class="sm:flex-shrink-0" v-if="img">
      <img
        class="lazyload rounded-full w-48 h-48 object-cover object-center"
        :data-src="img"
        alt="Woman paying for a purchase"
      />
    </div>
    <div class="mt-4 sm:mt-0 sm:ml-6 pb-6">
      <span v-if="label" class="uppercase tracking-wide text-sm text-gray-600 font-bold">{{ label }}</span>
      <h3 href="#" class="block mt-1">{{ name }}</h3>

      <p class="mt-4" v-if="telefon">
        Telefon
        <a
          class="border-b ml-1 pb-1 text-red-500 border-gray-200 hover:border-red-200 hover:text-red-600 font-medium"
          :href="`tel:${telefon}`"
        >{{ telefon }}</a>
      </p>
      <p class="mt-2" v-if="mail">
        Email
        <a
          class="border-b ml-1 pb-1 text-red-500 border-gray-200 hover:border-red-200 hover:text-red-600 font-medium"
          :href="`mailto:${mail}`"
        >{{ mail }}</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonCard',
  props: {
    label: String,
    name: String,
    img: String,
    telefon: String,
    mail: String,
  },
}
</script>
